import React, { PropTypes } from 'react';
import FlatButton from 'material-ui/FlatButton';
import ContentAddCircleOutline from 'material-ui/svg-icons/content/add-circle-outline';

class ClubCmsAddHeader extends React.Component {
  static propTypes = {
    label: PropTypes.node.isRequired,
    onClick: PropTypes.func.isRequired,
    color: PropTypes.string.isRequired
  };

  render() {
    let {
      color,
      label,
      onClick
    } = this.props;

    let headerStyle = {
      backgroundColor: color,
      paddingLeft: 16,
      paddingRight: 16
    };

    return (
      <div style={headerStyle}>
        {/*Add Button*/}
        <FlatButton labelStyle={{color: 'white'}} onClick={onClick}
                    icon={<ContentAddCircleOutline color="white" />}
                    label={label}/>
      </div>
    );
  }
}

ClubCmsAddHeader.defaultProps = {
  label: 'Add Title',
  color: 'gray'
};

export default ClubCmsAddHeader;




// WEBPACK FOOTER //
// ./src/components/ClubCMS/ClubCmsAddHeader.js